export function convertNumberArrayToIEntityArray(values: number[]) {
  return values.map((x) => ({id: x}));
}
